import {encodeTrailHeights,decodeTrailHeights,composeTrailHeight} from './sand-trails.js';

export const WORLD_SAVE_KEY='allwalks-world-v1';
export const WORLD_SAVE_VERSION=3;

const finiteBall=value=>Array.isArray(value)&&value.length===2&&value.every(Number.isFinite)?[value[0],value[1]]:null;

export function serializeWorldSave({n,heights,cuts,rims,ball,moved=false}){
 if(!Number.isInteger(n)||n<=1)throw new TypeError('Invalid terrain size');
 const count=n*n;
 for(const [name,field] of [['heights',heights],['cuts',cuts],['rims',rims]])if(!field||field.length!==count)throw new TypeError(`Invalid ${name} field`);
 return {
  version:WORLD_SAVE_VERSION,
  n,
  h16:encodeTrailHeights(heights),
  cuts16:encodeTrailHeights(cuts),
  rims16:encodeTrailHeights(rims),
  ball:finiteBall(ball),
  moved:!!moved
 };
}

export function deserializeWorldSave(data,{n}){
 const count=n*n;
 const empty=()=>({version:0,heights:new Float32Array(count),cuts:new Float32Array(count),rims:new Float32Array(count),ball:null,moved:false,migrated:false});
 if(!data||typeof data!=='object'||data.n!==n)return empty();
 const cuts=new Float32Array(count),rims=new Float32Array(count),heights=new Float32Array(count);
 const version=Number(data.version)||1;
 if(version===WORLD_SAVE_VERSION&&data.cuts16&&data.rims16){
  try{
   cuts.set(decodeTrailHeights({h16:data.cuts16},count));
   rims.set(decodeTrailHeights({h16:data.rims16},count));
   rebuildTrailHeights(cuts,rims,heights);
   return {version,heights,cuts,rims,ball:finiteBall(data.ball),moved:!!data.moved,migrated:false};
  }catch{}
 }
 if(!data.h16&&!data.h)return empty();
 let legacyHeights;
 try{legacyHeights=decodeTrailHeights(data,count);}catch{return empty();}
 heights.set(legacyHeights);
 for(let i=0;i<count;i++){cuts[i]=Math.min(0,heights[i]);rims[i]=Math.max(0,heights[i]);}
 return {version,heights,cuts,rims,ball:finiteBall(data.ball),moved:!!data.moved,migrated:true};
}

export function loadWorldSave(storage,{n,key=WORLD_SAVE_KEY}){
 try{
  const raw=(storage??localStorage).getItem(key);
  return deserializeWorldSave(raw?JSON.parse(raw):null,{n});
 }catch{return deserializeWorldSave(null,{n});}
}

export function saveWorldSave(state,storage,{key=WORLD_SAVE_KEY}={}){
 try{(storage??localStorage).setItem(key,JSON.stringify(serializeWorldSave(state)));return true;}catch{return false;}
}

export function rebuildTrailHeights(cuts,rims,target=new Float32Array(cuts.length)){
 if(cuts.length!==rims.length||target.length!==cuts.length)throw new TypeError('Invalid trail component dimensions');
 for(let i=0;i<target.length;i++)target[i]=composeTrailHeight(cuts[i],rims[i]);
 return target;
}
